import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showStickyNav, setShowStickyNav] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();

  const navLinks = [
    { path: '/', label: t('header.nav.home') },
    { path: '/about', label: t('header.nav.about') },
    { path: '/services', label: t('header.nav.services') },
    { path: '/prices', label: t('header.nav.prices') },
    { path: '/gallery', label: t('header.nav.gallery') },
    { path: '/contact', label: t('header.nav.contact') }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsScrolled(scrollY > 50);
      
      // Show sticky nav only when header is completely out of view (much higher threshold)
      if (scrollY > 500) {
        setShowStickyNav(true);
      } else {
        setShowStickyNav(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <LanguageSwitcher />
        <div className="header-content">
          <Link to="/" className="logo-block">
            <img src="/image/Head.png" alt="Sapium Beauty Logo" className="header-logo-image" />
            <div className="header-title-wrapper">
              <h1 className="header-title">
                <span className="title-sapium">
                  Sapi<span className="letter-u">u</span>m
                </span>
                <span className="title-beauty">Beauty</span>
              </h1>
              <p className="header-subtitle">aesthetic and laser studio</p>
            </div>
          </Link>
          <div className="header-contact-info">
            <p><strong>Skin Treatments:</strong> 28 Barking Rd, London E16 1EQ</p>
            <p><strong>Laser Hair Removal:</strong> {t('header.address')}, {t('header.city')}</p>
            <p>{t('header.phone')}</p>
            <p>{t('header.email')}</p>
          </div>

          <button 
            className="hamburger" 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className="nav">
            <ul>
              {navLinks.map(link => (
                <li key={link.path} className={location.pathname === link.path ? 'active' : ''}>
                  <Link 
                    to={link.path}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul>
            {navLinks.map(link => (
              <li key={link.path} className={location.pathname === link.path ? 'active' : ''}>
                <Link 
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </header>

      {/* Sticky Navigation - Only the menu buttons */}
      <div className={`sticky-menu ${showStickyNav ? 'visible' : ''}`}>
        <nav className="sticky-nav">
          <ul>
            {navLinks.map(link => (
              <li key={link.path} className={location.pathname === link.path ? 'active' : ''}>
                <Link to={link.path}>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Header; 